import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M3.406 3L2 6.604v14.732h5V24h2.813l2.656-2.664h4.062L22 15.85V3H3.406zm16.719 11.91L17 18.045h-5l-2.656 2.664v-2.664H5.125V4.88h15v10.03zM17 8.485v5.485h-1.875V8.485H17zm-5 0v5.485h-1.875V8.485H12z" }));
export default createSvgIcon(iconPath, "Twitch");
//# sourceMappingURL=TwitchIcon.js.map